module.exports = __webpack_public_path__ + "static/media/course_bg@2x.b62f8816.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/on/course_bg@2x.png
// module id = 583
// module chunks = 1